<template>
<div>
  <div class="main-content">
    <div class="content-block box">
      <div class="company-box">
        <p>会社コードは一般ユーザーがスマホアプリから会員登録をする際に使用します。</p>
        <table class="pure-table">
          <tbody>
            <tr>
              <td class="color-glay td-title">会社名</td>
              <td class="td-content">{{ companyName }}</td>
            </tr>
            <tr>
              <td class="color-glay td-title">会社コード</td> 
              <td class="td-content">{{ companyCode }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      companyName: "",
      companyCode: ""
    }
  },

  beforeMount() {
    this.getCompany()
  },

  methods: {
    getCompany() {
      if (this.$store.state.store.user.companyName != "" && this.$store.state.store.user.companyCode != "") {
        this.companyName = this.$store.state.store.user.companyName
        this.companyCode = this.$store.state.store.user.companyCode
      } else {
        this.$http.get("/company").then((res) => {
          this.companyName = res.data.companyName
          this.companyCode = res.data.companyCode
          this.$store.dispatch("setCompany" , res.data)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.company-box {
  text-align: center;
}

table {
  width: fit-content;
}

.pure-table {
  margin-left: auto;
  margin-right: auto;
}

tbody {
  display: initial;
}

.td-title {
  width: 100px;
}

.td-content {
  width: 200px;
}

.color-glay {
  background: linear-gradient(270deg, #fffaf0, #dcdcdc) !important;
}

@media screen and (max-width: 420px) {
  .company-box {
    margin: 10px;
  }
}
</style>